import HotelBook from '@/views/HotelBook/index.vue'

const HotelBookRouter = {
  path: '/hotel-book',
  name: 'HotelBook',
  component: HotelBook,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default HotelBookRouter
